import React from 'react';

import './CreatePost.scss';

import { TextShowcaseGroup } from '../../shared/TextShowcaseGroup/TextShowcaseGroup';
import { NewPostForm } from '../../../../../components/NewPostForm/NewPostForm';

interface ICreatePost {
  demoPostText: string;
};

export function CreatePost({ demoPostText }: ICreatePost) {
  return (
    <div className='CreatePost'>
      <TextShowcaseGroup isReverse={ false }  areItemsCentered={ true }>
        <div className='CreatePost__text'>
          <p>Type text and click "Post" button.</p>
          <div>
            You can post your:
            <ul className='CreatePost__bullets'>
              <li>predictions of any kind;</li>
              <li>promises, resolutions and life goals to have more motivation;</li>
              <li>bets or disagreements;</li>
              <li>challenges;</li>
              <li>etc.</li>
            </ul>
          </div>
        </div>
        <div>
          <NewPostForm isDemo={ true } hideHint={ true } addPostToState={ () => {} } defaultValue={ demoPostText } />
        </div>
      </TextShowcaseGroup>
    </div>
  );
}
